(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-swiper"] && !Shopify.designMode) return;
  try {
    

(function() {
  function initLcmHomeSwiper(scope) {
    if (typeof Swiper === 'undefined') return;

    var containers = scope.querySelectorAll('.lcm-home-swiper');

    containers.forEach(function(container) {
      if (container.dataset.swiperInitialized === 'true') return;

      var swiperElement = container.querySelector('.lcm-home-swiper__instance');
      if (!swiperElement) return;

      var nextButton = container.querySelector('.lcm-home-swiper__nav--next');
      var prevButton = container.querySelector('.lcm-home-swiper__nav--prev');
      var paginationElement = container.querySelector('.lcm-home-swiper__pagination');

      var autoplayEnabled = container.dataset.swiperAutoplay === 'true';
      var loopEnabled = container.dataset.swiperLoop === 'true';
      var speedValue = parseInt(container.dataset.swiperSpeed, 10) || 600;
      var delayValue = parseInt(container.dataset.swiperDelay, 10) || 7000;

      var swiperOptions = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: loopEnabled,
        speed: speedValue,
        watchOverflow: true,
        preloadImages: false,
        observer: true,
        observeParents: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        a11y: {
          enabled: true
        },
        autoplay: autoplayEnabled ? {
          delay: delayValue,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        } : false
      };

      if (paginationElement) {
        swiperOptions.pagination = {
          el: paginationElement,
          clickable: true
        };
      }

      if (nextButton && prevButton) {
        swiperOptions.navigation = {
          nextEl: nextButton,
          prevEl: prevButton
        };
      }

      new Swiper(swiperElement, swiperOptions);

      container.dataset.swiperInitialized = 'true';
    });
  }

  function runInit(context) {
    initLcmHomeSwiper(context || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      runInit(document);
    });
  } else {
    runInit(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    runInit(event.target);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-facebook-message"] && !Shopify.designMode) return;
  try {
    
	jQuery(document).ready(function($) {
		$(document).on('click', '.ss-fb-ms-bottom', function() {
			$('.ss-fb-ms-inner').show();
			$(this).hide();
		})

		$(document).on('click', '.offline_heading', function() {
			$('.ss-fb-ms-inner').hide();
			$('.ss-fb-ms-bottom').show();
		})
	})

  } catch(e) { console.error(e); }
})();
})();
